import { rioEvent } from '.';
export var sendClickStreamInteraction = function sendClickStreamInteraction(type, element, search, taxonomy) {
  rioEvent({
    type: 'clickstream_interaction',
    data: {
      interaction: {
        type: type,
        element: element
      },
      content: {
        metadata: {
          search: search
        },
        taxonomy: taxonomy
      }
    }
  });
};
export var sendClickStreamViewInteraction = function sendClickStreamViewInteraction(element, taxonomy) {
  rioEvent({
    type: 'clickstream_component_view',
    data: {
      component_view: {
        component: element
      },
      content: {
        taxonomy: taxonomy
      }
    }
  });
};
export var sendClickStreamNotification = function sendClickStreamNotification(notifications) {
  rioEvent({
    type: 'clickstream_notifications',
    data: {
      notifications: notifications
    }
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-plat-ui/utils/dist/esm/rio/events.js
// module id = 5776
// module chunks = 11